<template>
    <section>
    <Header 
    :header_page_data="headerPageData"
    ></Header>
    <DeleteLocationModalOffline
                :respondent="currentRespondentComputed"
                :campaign="currentCampaign"
    ></DeleteLocationModalOffline>
      <section>
        <div class="container container-app">
            <section class="position-relative campaigns-container">
                <form @submit.prevent="saveRespondent" class="mt-2">
                    <div v-if="typeof currentRespondentComputed.status != 'undefined' && currentRespondentComputed.status == 'error'" class="row">
                        <div v-if="currentRespondentComputed.error_reason == 'ZERO_RESULTS'" class="col-12 offline-errors-processing">
                            {{ $t('add_location.errors.zero_results_error') }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="row" :class="{'modal-footer-canvassing-redish pt-2': hasError(errors, 'name')}">
                                <div class="col-12">
                                    <span class="add-location-title float-left">{{ $t('add_location.title') }}</span>
                                    <div class="form-group position-relative mb-3">
                                        <input type="text" class="form-control form-control--canvassing border-bottom" v-model="form.name" id="name">
                                        <div v-if="hasError(errors, 'name')">
                                            <span class="text-danger">{{errors.name[0]}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>         
                        </div>
                    </div>         
                    <div class="row" :class="{'modal-footer-canvassing-redish pt-2': hasError(errors, 'location')}">
                        <div class="col-12">
                            <span class="add-location-title float-left">{{ $t('add_location.location_address') }}</span>
                        </div>
                        <div class="col-12 mb-3 edit-location">
                            <div v-if="$store.getters['online']">
                                <gmap-autocomplete
                                    :options="{
                                        fields: ['geometry.location', 'formatted_address'],
                                    }"
                                    ref="autocomplete"
                                    @place_changed="setPlace"
                                    :placeholder="(typeof currentRespondentComputed.status != 'undefined' && currentRespondentComputed.status == 'error') ? $t('campaign_map.search') : form.location.full_address"
                                    :select-first-on-enter="true"
                                    @input="googleAutocompleteChange"
                                >
                                </gmap-autocomplete>
                                <button v-if="showIcs" class="btn btn-light google-clear-button" @click="clearPlaceInput"><img src="./../../assets/ics_search.svg" alt="search" /></button>
                            </div>
                            <div v-else>
                                <input type="text" class="mini-marker-add-edit-pl form-control form-control--canvassing border-bottom" v-model="form.location.full_address" id="location">
                            </div>
                    <div v-if="hasError(errors, 'location')">
                        <span class="text-danger">{{errors.location[0]}}</span>
                    </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="row" :class="{'modal-footer-canvassing-redish pt-2': hasError(errors, 'reception')}">
                                <div class="col-12">
                                    <span class="add-location-title float-left mb-3">{{ $t('add_location.campaign_reception') }}</span>
                                </div>
                                <div class="col-12">
                                    <span class="starRating" id="reception">
                                        <input id="rating5" type="radio" name="rating" value="5" v-model="form.reception">
                                        <label for="rating5"></label>
                                        <input id="rating4" type="radio" name="rating" value="4" v-model="form.reception">
                                        <label for="rating4"></label>
                                        <input id="rating3" type="radio" name="rating" value="3" v-model="form.reception">
                                        <label for="rating3"></label>
                                        <input id="rating2" type="radio" name="rating" value="2" v-model="form.reception">
                                        <label for="rating2"></label>
                                        <input id="rating1" type="radio" name="rating" value="1" v-model="form.reception">
                                        <label for="rating1"></label>
                                    </span>
                                </div>
                                <div class="col-12">
                                    <span class="starRatingLabels">
                                        <span class="float-left ml-3 reception-labels">{{ $t('add_location.annoyed') }}</span><span class="float-right mr-2 reception-labels">{{ $t('add_location.happy') }}</span>
                                    </span>
                                </div>
                                <div class="col-12 mb-3">
                                    <div v-if="hasError(errors, 'reception')">
                                        <span class="text-danger">{{errors.reception[0]}}</span>
                                    </div>
                                </div>
                            </div>                           
                        </div>                        
                        <div class="col-12">
                            <span class="add-location-title float-left mt-3 mb-3" id="answers">{{ $t('add_location.talking_points') }}</span>
                        </div>
                        <div v-if="hasError(errors, 'answers')">
                            <span class="text-danger">{{errors.answers[0]}}</span>
                        </div>
                        <div class="col-12">
                            <div v-for="(question, index) in currentCampaign.questions" v-if="question.is_visible == true" class="row mb-3" :class="{'modal-footer-canvassing-redish': hasError(errors.answers, question._id)}" :key="index" :id="question._id">
                                <div class="col-12">
                                    <span class="question-text">{{question.text}}</span>
                                </div>
                                <div v-if="question.type == 'open'" class="col-12">
                                    <textarea :placeholder="form.answers[question._id].length == 0 ? $t('add_location.response-placeholder') : ''" class="free-question-textarea" :name="question._id" v-model="form.answers[question._id]">{{ form.answers[question._id] }}</textarea>
                                </div>
                                <div v-else v-for="(answer, indexAnswer) in question.answers" class="col-12" :key="indexAnswer">
                                    <input :type="question.type == 'single' ? 'radio' : 'checkbox'" :id="answer._id" :name="question.type == 'single' ? question._id  : answer._id" :value="answer._id" v-model="form.answers[question._id]">
                                    <label class="mr-2" :for="answer._id"><span></span><div class="answer-text">{{ answer.text }}</div></label>
                                </div>
                                <div class="col-12 mb-3">
                                    <div v-if="hasError(errors.answers, question._id)">
                                        <span class="text-danger ml-3">{{errors.answers[question._id][0]}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <span class="created-edited-label">{{ $t('add_location.created_by') }} <span class="weight-500">{{ currentRespondentComputed.created_by.name }}</span> </span>
                        </div>
                        <div class="col-12 mb-3">
                            <span class="created-edited-label">{{ $t('add_location.edited_by') }} <span class="weight-500">{{ (typeof currentRespondentComputed.updated_by != 'undefined') ? currentRespondentComputed.updated_by.name : currentRespondentComputed.created_by.name }}</span></span>
                        </div>
                    </div>
                    <div class="row mb-5">
                        <div class="col-6">
                            <button type="submit" class="btn shadow btn-app btn-block primaryBackground">{{ $t('add_location.save_location') }}</button>
                        </div>
                        <div class="col-6">
                            <button @click.prevent="cancelAddRespondent" class="btn shadow btn-app btn-block cancelOrangeButton">{{ $t('add_location.cancel') }}</button>
                        </div>
                    </div>
                </form>

                <div class="row modal-footer-canvassing-redish mt-5">
                    <div class="col-12 mt-4 mb-4 d-flex">
                        <span data-toggle="modal" data-target="#deleteLocationModalOffline" class="modal-footer-canvassing-red-button mx-auto cursor-pointer">{{ $t('campaign_settings.delete_location') }}</span>
                    </div>
                    <div class="col-12 text-center mb-2">
                        <p class="note-text">{{ $t('campaign_settings.note_delete_location') }}</p>
                    </div>
                </div>
            </section>
        </div>
      </section>
    </section>
</template>

<script>
    import Header from "./../layouts/Header";
    import DeleteLocationModalOffline from "../modals/DeleteLocationModalOffline";
    import HelperMixin from "./../../mixins/HelperMixin";

    export default {
        name: "EditLocationOffline",
        components: {Header, DeleteLocationModalOffline},
        mixins: [HelperMixin],
        data() {
            return {
                showIcs: false,
                form: {
                    name: '',
                    reception: 1,
                    location: {},
                    answers: {}
                },
                errors: {
                    name: [],
                    location: [],
                    reception: [],
                    answers: []
                },
                headerPageData: {
                    title: this.$store.getters["currentCampaign"].name,
                    search: {
                        show: false,
                        type_search: ''
                    },
                    settings: {
                        show: true,
                        campaign: this.$store.getters["currentCampaign"]
                    },
                    home: {
                        show: true,
                    },
                    profile: {
                        show: false
                    }
                }
            }
        },
        created() {
             if (typeof this.currentRespondentComputed.location == 'undefined') {
                this.goto('campaign-map', {campaign_id: this.$route.params.campaign_id});
            } else {
                this.form.name = this.currentRespondentComputed.name;
                this.form.reception = this.currentRespondentComputed.reception;
                this.form.location = this.currentRespondentComputed.location;
                this.mapAnswersErrors();
                this.mapAnswersModels();
                this.mapEditAnswers();
                if (typeof this.currentRespondentComputed.status != 'undefined' && this.currentRespondentComputed.status == 'error') {
                    if (this.currentRespondentComputed.error_reason == 'ZERO_RESULTS') {
                        this.errors.location = [this.$t('add_location.errors.location_address_required')];
                    }
                }
            }
        },
        mounted() {

        },
        computed: {
            currentRespondentComputed() {
                return this.$store.getters["currentRespondentOffline"];
            },

            currentCampaign() {
                return this.$store.getters["currentCampaign"];
            }
        },
        methods: {
            googleAutocompleteChange() {
                if (this.$refs.autocomplete.$el.value != '') {
                    this.showIcs = true;
                } else {
                    this.showIcs = false;
                }
            },

            clearPlaceInput() {
                 this.$refs.autocomplete.$el.value = '';
                 this.showIcs = false;
            },
            
            setPlace(place) {
                if (typeof place.geometry != 'undefined') {
                
                    this.form.location = {
                        full_address: place.formatted_address,
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                    };                    
                }
            },

            cancelAddRespondent() {
                this.goto('campaign-map', {campaign_id: this.$route.params.campaign_id});
            },

            saveRespondent() {
                let answers = this.mapAnswers();
                if (typeof this.form.location.id != 'undefined') {
                    delete this.form.location.id;
                }
                
                this.errors = {
                    name: [],
                    location: [],
                    reception: [],
                    answers: []
                };

                this.mapAnswersErrors();

                let _this = this;
                let exit = [];
                Object.keys( this.form.answers).forEach(function(key) {
                    for (var i = 0; i < _this.currentCampaign.questions.length; i++) {
                        if (key == _this.currentCampaign.questions[i]['_id']) {
                            if (_this.currentCampaign.questions[i].type == 'open') {
                                if (_this.currentCampaign.questions[i].is_mandatory === true && _this.form.answers[key].length == 0) {
                                    _this.errors.answers[key] = [_this.$t('add_location.errors.please_complete_response')];
                                    exit.push(1);
                                }

                                if (_this.form.answers[key].length > 500) {
                                    _this.errors.answers[key] = [_this.$t('add_location.errors.response_max_length')];
                                    exit.push(1);
                                }

                                if (_this.currentCampaign.questions[i].validation == 'integer' && _this.form.answers[key].length > 0) {
                                    var valueFormat = /^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g;
                                    if ((Array.isArray(_this.form.answers[key]) && _this.form.answers[key][0].match(valueFormat) == null) ||
                                        (Array.isArray(_this.form.answers[key]) == false && _this.form.answers[key].match(valueFormat) == null)
                                    ) {
                                        _this.errors.answers[key] = [_this.$t('add_location.errors.response_validation_number')];
                                        exit.push(1);
                                    }
                                }

                                if (_this.currentCampaign.questions[i].validation == 'email' && _this.form.answers[key].length > 0) {
                                    var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                                    if ((Array.isArray(_this.form.answers[key]) && _this.form.answers[key][0].match(mailformat) == null) ||
                                        (Array.isArray(_this.form.answers[key]) == false && _this.form.answers[key].match(mailformat) == null)
                                    ) {
                                        _this.errors.answers[key] = [_this.$t('add_location.errors.response_validation_email')];
                                        exit.push(1);
                                    }
                                }
                            } else {
                                if (_this.form.answers[key].length == 0) {
                                    if(_this.currentCampaign.questions[i].is_mandatory === true && _this.form.answers[key].length == 0) {
                                        _this.errors.answers[key] = [_this.$t('add_location.errors.please_complete_response')];
                                        exit.push(1);
                                    } 
                                }
                            }

                        }
                    }
                });

                if(this.currentCampaign.reception_mandatory == true && this.form.reception == 0) {
                    _this.errors.reception = [_this.$t('add_location.errors.reception_required')];
                    exit.push(1);
                }

                if (this.form.name == '') {
                    this.errors.name = [this.$t('add_location.errors.name_required')];
                    exit.push(1);
                }
                if (this.form.name.length < 2) {
                    this.errors.name = [this.$t('add_location.errors.name_min')];
                    exit.push(1);
                }
                if (this.form.name.length > 60) {
                    this.errors.name = [this.$t('add_location.errors.name_max')];
                    exit.push(1);
                }

                if (this.form.location.full_address == '') {
                    this.errors.location = [this.$t('add_location.errors.location_address_required')];
                    exit.push(1);
                }

                if (exit.length > 0) {
                    return false;
                }

                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });
                let data = this.currentRespondentComputed;
                data.name = this.form.name;
                data.answers = answers;
                data.reception = this.form.reception;
                data.location = this.form.location;
                data.status = 'pending';
                data.created_by = {
                    id: this.$store.getters["user"]._id,
                    name: this.$store.getters["user"].name
                };

                this.$store.dispatch('saveOfflineLocation', {
                    offlineLocation: data
                });

                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });

                this.errors = {
                    name: [],
                    location: [],
                    reception: [],
                    answers: []
                };

                this.mapAnswersErrors();
                if (this.$store.getters['online']) {
                    this.createRespondentFromOffline();
                }

                this.goto('campaign-locations', {campaign_id: this.$route.params.campaign_id});

            },

            mapEditAnswers() {
                var mergedAnswers = {};
                for (var i = 0; i < this.currentRespondentComputed.answers.length; i++) {
                    mergedAnswers[this.currentRespondentComputed.answers[i].question_id] = [];
                }
                for (var i = 0; i < this.currentRespondentComputed.answers.length; i++) {
                    mergedAnswers[this.currentRespondentComputed.answers[i].question_id].push(typeof this.currentRespondentComputed.answers[i].answer_id != 'undefined' ? this.currentRespondentComputed.answers[i].answer_id : this.currentRespondentComputed.answers[i].answer);
                }
                for (var i = 0; i < this.currentCampaign.questions.length; i++) {
                    for (var j = 0; j < this.currentRespondentComputed.answers.length; j++) {
                        if (this.currentCampaign.questions[i]._id == this.currentRespondentComputed.answers[j].question_id && this.currentCampaign.questions[i].type == 'single') {
                            this.form.answers[this.currentRespondentComputed.answers[j].question_id] = typeof mergedAnswers[this.currentRespondentComputed.answers[j].question_id][0] != 'undefined' ? mergedAnswers[this.currentRespondentComputed.answers[j].question_id][0] : '';
                        }
                        if (this.currentCampaign.questions[i]._id == this.currentRespondentComputed.answers[j].question_id && this.currentCampaign.questions[i].type == 'multiple') {
                            this.form.answers[this.currentRespondentComputed.answers[j].question_id] = mergedAnswers[this.currentRespondentComputed.answers[j].question_id];
                        }
                        if (this.currentCampaign.questions[i]._id == this.currentRespondentComputed.answers[j].question_id && this.currentCampaign.questions[i].type == 'open') {
                            this.form.answers[this.currentRespondentComputed.answers[j].question_id] = typeof mergedAnswers[this.currentRespondentComputed.answers[j].question_id][0] != 'undefined' ? mergedAnswers[this.currentRespondentComputed.answers[j].question_id][0] : '';
                        }
                    }

                }
            },

            mapAnswersModels() {
                if (typeof this.currentCampaign.questions != 'undefined') {
                    for (var i = 0; i < this.currentCampaign.questions.length; i++) {
                        if (this.currentCampaign.questions[i].is_visible == true) {
                            if ( this.currentCampaign.questions[i].type == 'single' || this.currentCampaign.questions[i].type == 'open') {
                                this.form.answers[this.currentCampaign.questions[i]._id] = '';   
                            } else {
                                this.form.answers[this.currentCampaign.questions[i]._id] = [];
                            }
                        }
                    }
                }
            },

            mapAnswers() {
                let tmp = [];
                let _this = this;
                Object.keys( this.form.answers).forEach(function(key,index) {
                    if (Array.isArray(_this.form.answers[key])) {
                        for (var i = 0; i < _this.form.answers[key].length; i++) {
                            if (_this.currentCampaign.questions[index].type == 'open') {
                                tmp.push({question_id: key, answer: _this.form.answers[key][i]});
                            } else {
                                tmp.push({question_id: key, answer_id: _this.form.answers[key][i]});
                            }
                        }
                    } else {
                        for (var i = 0; i < _this.currentCampaign.questions.length; i++) {
                            if (key == _this.currentCampaign.questions[i]['_id']) {
                                if (_this.currentCampaign.questions[i]['type'] == 'open') {
                                    tmp.push({question_id: key, answer: _this.form.answers[key]});
                                } else {
                                    tmp.push({question_id: key, answer_id: _this.form.answers[key]});
                                }
                            }
                        }
                    }
                });
                
                return tmp;
            },

            mapAnswersErrors() {
                if (typeof this.currentCampaign.questions != 'undefined') {
                    for (var i = 0; i < this.currentCampaign.questions.length; i++) {
                        if (this.currentCampaign.questions[i].is_visible == true) {
                            this.errors.answers[this.currentCampaign.questions[i]._id] = [];
                        }
                    }
                }
            },
        },
    };
</script>
